<template>
    <div>
        <button type="button"
                class="btn"
                :class="{
                    'btn-success': showEnableVariant,
                    'btn-primary': !showEnableVariant,
                    'spinner spinner-white spinner-sm spinner-left': formIsProcessing
                }"
                :disabled="isDisabled"
                @click="$emit('click')"
        >
            <i v-show="!formIsProcessing" class="fas fa-save"/>
            {{ buttonText }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        showEnableVariant: Boolean,
        disabled: Boolean,
        for: Object //Inertia form
    },

    computed: {
        buttonText() {
            if (this.showEnableVariant) {
                return __('actions.submit_and_enable');
            }

            return __('actions.submit');
        },

        formIsProcessing() {
            return this.for?.processing === true;
        },

        isDisabled() {
            return this.disabled || this.formIsProcessing || this.for?.isDirty === false;
        }
    }
}
</script>
